import { createAsyncThunk } from '@reduxjs/toolkit';
import fetchTrayWizardCode from './fetchTrayWizardCode';
import { generateTrayWizardUrl } from '../../../helpers/connectionManager';

export default createAsyncThunk('connectionManager/updateTrayInstanceWizard', async (payload, { dispatch }) => {
  const { solutionInstance } = payload;

  const { payload: code } = await dispatch(fetchTrayWizardCode());

  if (!code) {
    throw new Error("couldn't create a edit wizard instance");
  }

  const trayWizardUrl = generateTrayWizardUrl(solutionInstance.id, code);

  return { solutionInstance: { ...solutionInstance, trayWizardUrl } };
});
